
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marine-algae",
      function () {
        return require("private-next-pages/marine-algae/index.js");
      }
    ]);
  